import axios from "axios";
import ServicesStore from "./stores/ServicesStore";
let baseURL;
let timeout = 15000;
if(window.location.hostname === "localhost") {
	baseURL = "//" + window.location.hostname + ":8000" + "/api";
	timeout = 15000;
} else {
	baseURL = "https://calendar.kaoz.space/api";
}

class EndPoint {
	constructor () {
		var API = axios.create({
			baseURL,
			timeout
		});
		API.interceptors.response.use((response) => {
			return response;
		},(error) => {
			if (error.response && error.response.status === 400) {
				ServicesStore.emit("logout");
			}
			return Promise.reject(error);
		});
		API.interceptors.request.use((config) => {
			config.headers["Authorization"] = this.getToken();
			return config;
		});
		this.API = API;
	}
	setToken (token) {
		localStorage.setItem("token", token);
	}
	getToken () {
		return localStorage.getItem("token");
	}
}
const appEndPoint = new EndPoint();

export default appEndPoint;

export const api = appEndPoint.API;


/** WEBPACK FOOTER **
 ** ./src/rest.js
 **/